(() => {
  try {
    const EXPIRY_MS = 30 * 60 * 1000;
    const setSessionValue = (key, value) => {
      sessionStorage.setItem(key, value);
      sessionStorage.setItem(`${key}_expires`, String(Date.now() + EXPIRY_MS));
    };
    const getSessionValue = (key) => {
      const expires = parseInt(sessionStorage.getItem(`${key}_expires`) || '0', 10);
      if (!expires || Date.now() > expires) {
        sessionStorage.removeItem(key);
        sessionStorage.removeItem(`${key}_expires`);
        return '';
      }
      return sessionStorage.getItem(key) || '';
    };
    const setSessionValueOnce = (key, value) => {
      const existing = getSessionValue(key);
      if (existing) {
        return existing;
      }
      setSessionValue(key, value);
      return value;
    };
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    const utmCampaign = params.get('utm_campaign');
    const campaignId = params.get('campaignid') || params.get('campaignId');

    if (ref !== null && utmCampaign !== null && campaignId !== null) {
      setSessionValueOnce('ref', ref);
      setSessionValueOnce('utm_campaign', utmCampaign);
      setSessionValueOnce('campaignid', campaignId);
    }

    const storedRef = getSessionValue('ref');
    const storedUtmCampaign = getSessionValue('utm_campaign');
    const storedCampaignId = getSessionValue('campaignid');
    const isSocialRef = storedRef === 'social';

    const FEBOFFER_CAMPAIGN_ID = '3d81bbdaccc3965c9e7be3ea8354ad7fa114ccb5';
    const FREEMAG_CAMPAIGN_ID = 'f7e6d5c4b3a2freemag';

    const isFebOffer =
      storedUtmCampaign === 'FEBOFFER' && isSocialRef && storedCampaignId === FEBOFFER_CAMPAIGN_ID;
    // FREEMAG: match on ref + campaignid only (Klaviyo sets utm_campaign to campaign name e.g. "Free Magnesium (01KK0D5TTMYPWB46S691Z6KJXH)")
    const isFreemag = isSocialRef && storedCampaignId === FREEMAG_CAMPAIGN_ID;

    const updateAnnouncementBar = () => {
      const announcementNodes = document.querySelectorAll(
        '.announcement-bar__static-list p, .announcement-bar__scrolling-list p'
      );
      if (!announcementNodes.length) {
        return;
      }

      const messageHtml = [
        '<span class="announcement-private-offer">',
        '<span class="announcement-private-offer__heading">You&#39;ve unlocked a Private Gift Card offer.</span>',
        '<span class="announcement-private-offer__body">Access via invitation only. Spend $150 and get a $30 gift card or spend $500 and get a $150 gift card.</span>',
        '<span class="announcement-private-offer__footer">Gift card sent with your order. Offer ends 28th Feb 2026 unless sold out earlier. Not valid with any other offer or discount. Not valid with subscription orders.</span>',
        '</span>',
      ].join('');

      announcementNodes.forEach((node) => {
        node.innerHTML = messageHtml;
      });
    };

    const setAnnouncementOfferState = () => {
      const bars = document.querySelectorAll('.announcement-bar');
      if (!bars.length) {
        return;
      }
      bars.forEach((bar) => {
        bar.classList.add('announcement-bar--offer-active');
      });
    };

    const ensureAnnouncementVisible = () => {
      const bars = document.querySelectorAll('[data-announcement-storage-key]');
      bars.forEach((bar) => {
        const storageKey = bar.getAttribute('data-announcement-storage-key');
        if (storageKey) {
          localStorage.removeItem(storageKey);
        }
        const section = bar.closest('[id^="shopify-section-"]');
        if (section) {
          section.style.display = '';
          document.documentElement.style.setProperty(
            '--announcement-bar-height',
            `${Math.round(section.clientHeight)}px`
          );
        }
      });
    };

    const removeWidget = (id) => {
      const el = document.getElementById(id);
      if (el && el.parentNode) el.parentNode.removeChild(el);
    };
    removeWidget('feboffer-rebuy');
    removeWidget('freemag-rebuy');

    if (isFebOffer) {
      const widget = document.createElement('div');
      widget.id = 'feboffer-rebuy';
      widget.setAttribute('data-rebuy-id', '268778');
      document.body.appendChild(widget);
      ensureAnnouncementVisible();
      setAnnouncementOfferState();
      updateAnnouncementBar();
    } else if (isFreemag) {
      // FREEMAG: widget only — do not change announcement bar
      const widget = document.createElement('div');
      widget.id = 'freemag-rebuy';
      widget.setAttribute('data-rebuy-id', '276926');
      document.body.appendChild(widget);
    }
  } catch (e) {
    // no-op
  }
})();
